import React from "react";
import Loader from "../../../../../../../components/Loader";

const IconHistory = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm107.5-150.9L273.4 250V120c0-6.6-5.4-12-12-12h-10.9c-6.6 0-12 5.4-12 12v145.1c0 3.5 1.5 6.8 4.1 9.1l95.5 81.3c4.9 4.2 12.3 3.5 16.5-1.4l8.2-9.6c4.2-4.9 3.5-12.3-1.4-16.5z"></path></svg>;

const RevisionPanel = ({
    operationType = "",
    newGroupName = "",
    newGroupDescription = "",
    messages = [],
    mentionAll = false,
    ephemeralExpiration = "off",
    sendingSpeed = "normal",
    campaignSelected = [],
    gruposSelecionados = [],
    schedulingType = "now",
    scheduledAt = "",
    setEtapaAtual,
    primaryColor = "#51a197",
    handleConfirm,
    isProcessing = false,

    restrictAnnouncement = false,
    maxMembers = 0,
    ephemeralHours = 0,

    newGroupPicture = null,
}) => {
    const campaignsCount = (campaignSelected || []).length;
    const groupsCount = (gruposSelecionados || []).length;
    const messagesCount = (messages || []).length;

    const getEphemeralLabelFromSeconds = (seconds) => {
        const s = Number(seconds);
        if (s === 0) return "Desativado";
        if (s === 86400) return "24 horas";
        if (s === 604800) return "7 dias";
        if (s === 7776000) return "90 dias";
        return `${s} segundos`;
    };

    const getEphemeralLabel = (val) => {
        const labels = { off: 'Desativado', '24h': '24 Horas', '7d': '7 Dias', '90d': '90 Dias' };
        return labels[val] || val;
    };

    const getSpeedLabel = (val) => {
        const labels = { fast: 'Rápida', normal: 'Normal', slow: 'Lenta' };
        return labels[val] || val;
    };

    return (
        <div style={{ maxWidth: "850px", margin: "0 auto", paddingBottom: "40px" }}>
            <div style={{ textAlign: "center", marginBottom: 32 }}>
                <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '64px', height: '64px', borderRadius: '20px', background: `${primaryColor}15`, color: primaryColor, marginBottom: '16px', fontSize: '32px' }}><IconHistory /></div>
                <h2 style={{ color: "#005c53", fontSize: "28px", fontWeight: "bold" }}>Revisão da Operação</h2>
                <p style={{ color: "#666" }}>Confirme os detalhes antes de processar em lote.</p>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, marginBottom: 32 }}>

                {/* Card: Configuração */}
                <div style={{ background: "#f8fafc", padding: 24, borderRadius: 20, border: "1px solid #e2e8f0", boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                    <div style={{ color: primaryColor, fontWeight: 'bold', marginBottom: 15, fontSize: '18px', borderBottom: '1px solid #e2e8f0', paddingBottom: 10 }}>Configuração da Ação</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        <div>
                            <span style={{ color: '#64748b', fontSize: '13px' }}>Tipo Técnico:</span>
                            <span style={{ fontWeight: 'bold', marginLeft: '5px', color: '#1e293b' }}>{operationType}</span>
                        </div>

                        {operationType === 'SendMessageGroup' && (
                            <>
                                <div><span style={{ color: '#64748b', fontSize: '13px' }}>Conteúdo:</span> <span style={{ fontWeight: 'bold' }}>{messagesCount} itens no fluxo</span></div>
                                <div><span style={{ color: '#64748b', fontSize: '13px' }}>Menções @todos:</span> <span style={{ fontWeight: 'bold' }}>{mentionAll ? "Ativado" : "Desativado"}</span></div>
                                <div><span style={{ color: '#64748b', fontSize: '13px' }}>Temporária:</span> <span style={{ fontWeight: 'bold', color: primaryColor }}>{getEphemeralLabel(ephemeralExpiration)}</span></div>
                                <div><span style={{ color: '#64748b', fontSize: '13px' }}>Velocidade:</span> <span style={{ fontWeight: 'bold', textTransform: 'capitalize' }}>{getSpeedLabel(sendingSpeed)}</span></div>
                            </>
                        )}

                        {operationType === 'ChangeGroupName' && (
                            <div>
                                <span style={{ color: '#64748b', fontSize: '13px' }}>Novo Nome:</span>
                                <div style={{ fontWeight: 'bold', fontSize: '16px', marginTop: 5, background: '#fff', padding: '8px 12px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                    {newGroupName || "Nenhum informado"}
                                </div>
                            </div>
                        )}

                        {operationType === 'ChangeGroupDescription' && (
                            <div>
                                <span style={{ color: '#64748b', fontSize: '13px' }}>Nova Descrição:</span>
                                <div style={{ fontSize: '14px', marginTop: 5, background: '#fff', padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0', whiteSpace: 'pre-wrap', maxHeight: '100px', overflowY: 'auto', fontStyle: 'italic' }}>
                                    {newGroupDescription || "A descrição será removida/limpa."}
                                </div>
                            </div>
                        )}
                        {operationType === 'ChangeGroupPicture' && (
                            <div>
                                <span style={{ color: '#64748b', fontSize: '13px' }}>Nova Imagem:</span>
                                {newGroupPicture ? (
                                    <div style={{ marginTop: 8, width: "80px", height: "80px", borderRadius: "12px", overflow: "hidden", border: "2px solid #fff", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
                                        <img src={newGroupPicture} alt="Nova" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                    </div>
                                ) : (
                                    <div style={{ fontWeight: 'bold', color: '#ef4444' }}>Não selecionada</div>
                                )}
                            </div>
                        )}

                        {operationType === 'ChangeGroupSettings' && (
                            <>
                                <div><span style={{ color: '#64748b', fontSize: '13px' }}>Apenas Admins:</span> <span style={{ fontWeight: 'bold' }}>{restrictAnnouncement ? "Sim" : "Não"}</span></div>
                                <div><span style={{ color: '#64748b', fontSize: '13px' }}>Limite de Membros:</span> <span style={{ fontWeight: 'bold' }}>{maxMembers}</span></div>
                                <div><span style={{ color: '#64748b', fontSize: '13px' }}>Mensagem Temporária:</span> <span style={{ fontWeight: 'bold' }}>{getEphemeralLabelFromSeconds(ephemeralHours)}</span></div>
                            </>
                        )}
                    </div>
                </div>

                {/* Card: Agendamento */}
                <div style={{ background: "#f8fafc", padding: 24, borderRadius: 20, border: "1px solid #e2e8f0", boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                    <div style={{ color: "#f59e0b", fontWeight: 'bold', marginBottom: 15, fontSize: '18px', borderBottom: '1px solid #e2e8f0', paddingBottom: 10 }}>Programação</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        <div><span style={{ color: '#64748b', fontSize: '13px' }}>Modo de Execução:</span> <span style={{ fontWeight: 'bold', color: schedulingType === 'now' ? '#166534' : '#92400e' }}>{schedulingType === 'now' ? 'Imediata' : 'Programada'}</span></div>
                        {schedulingType === 'scheduled' && (
                            <div><span style={{ color: '#64748b', fontSize: '13px' }}>Data e Horário:</span> <div style={{ fontWeight: 'bold', fontSize: '15px', color: '#1e293b', marginTop: 5, background: '#fffbeb', padding: '8px 12px', borderRadius: '8px', border: '1px solid #fde68a' }}>{new Date(scheduledAt).toLocaleString('pt-BR')}</div></div>
                        )}
                    </div>
                </div>

                {/* Card: Destinos */}
                <div style={{ gridColumn: "span 2", background: "#f8fafc", padding: 24, borderRadius: 20, border: "1px solid #e2e8f0", display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                    <div style={{ background: '#fff', padding: 15, borderRadius: 15, textAlign: 'center', border: '1px solid #eff6ff' }}>
                        <div style={{ fontSize: '32px', fontWeight: '900', color: '#2563eb' }}>{campaignsCount}</div>
                        <div style={{ fontSize: '12px', color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase' }}>Campanhas Alvo</div>
                    </div>
                    <div style={{ background: '#fff', padding: 15, borderRadius: 15, textAlign: 'center', border: '1px solid #eff6ff' }}>
                        <div style={{ fontSize: '32px', fontWeight: '900', color: '#2563eb' }}>{groupsCount}</div>
                        <div style={{ fontSize: '12px', color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase' }}>Grupos Selecionados</div>
                    </div>
                </div>
            </div>

            <div style={{ display: "flex", gap: 20, justifyContent: "center" }}>
                <button onClick={() => setEtapaAtual("content")} disabled={isProcessing} style={{ padding: "16px 32px", cursor: "pointer", background: "#fff", color: "#64748b", border: "2px solid #e2e8f0", borderRadius: 16, fontWeight: 'bold' }}>Voltar e Editar</button>
                <button onClick={handleConfirm} disabled={isProcessing} style={{ padding: "16px 80px", cursor: isProcessing ? "not-allowed" : "pointer", background: isProcessing ? "#ccc" : primaryColor, color: "#fff", border: "none", borderRadius: 16, fontWeight: 'bold', fontSize: '16px', boxShadow: isProcessing ? "none" : `0 10px 15px -3px ${primaryColor}44` }}>
                    {isProcessing ? "Processando..." : "Confirmar Operação"}
                </button>
                {isProcessing && <Loader />}
            </div>
        </div>
    );
};

export default RevisionPanel;